module.exports = __webpack_public_path__ + "img/logo.7b432c40.png";